import Input from '../components/atoms/Input/index.js';

const About = () => {
  return (
    <div>
      <h1>소개</h1>
      <p>리액트 라우터를 사용해 보는 프로젝트입니다.</p>
      <Input />
    </div>
  );
};

export default About;
